import { render, staticRenderFns } from "./orderItemStatisticsList.vue?vue&type=template&id=52114298&scoped=true"
import script from "./orderItemStatisticsList.vue?vue&type=script&lang=js"
export * from "./orderItemStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./orderItemStatisticsList.vue?vue&type=style&index=0&id=52114298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52114298",
  null
  
)

component.options.__file = "orderItemStatisticsList.vue"
export default component.exports